import {Env} from "@morningtrain/helpers";
import {Resources} from "@morningtrain/resources";

export default class LaravelRepositoryAdapter {

    constructor({namespace, resourceName, operationName}) {
        this.operation = Resources.make(namespace, resourceName).operation(operationName, {});
    }

    get(query, defaultValue = null) {
        return Env.get(query, defaultValue);
    }

    load(locale) {
        return this.operation.execute({locale})
            .then((data) => {
                Env.set(["translations", locale].join("."), data);
            })
            .catch(() => {
                throw new Error('Failed to load locale "' + locale + '" - operation failed');
            });
    }

};